import {Ref, ref} from 'vue';
import {B2BLeadForm} from "../../../../../models/forms";
import {contentTypes} from "../../../../../di/types";
import {SendBusinessFormUseCase} from "../../../application";

export function useB2BNewLeadForm() {
  const {$container} = useNuxtApp();
  const sendBusinessFormUseCase: SendBusinessFormUseCase = $container.get<SendBusinessFormUseCase>(contentTypes.SendBusinessFormUseCase);

  const {t} = useI18n();
  const {yup, validate} = useValidator();

  const isLoading = ref(false);
  const formData: Ref<B2BLeadForm> = ref({
    company: null,
    countOfStaff: null,
    format: [],
    name: null,
    phone: null,
    country: 'ua',
    email: null,
  });

  const validationSchema = computed(() => {
    return yup.object().shape({
      company: yup.string().required(),
      countOfStaff: yup.number().required(),
      format: yup.array()
        .min(1)
        .required(),
      name: yup.string()
        .min(3)
        .max(70)
        .required(),
      phone: yup.string().phone(formData.value.country).required(),
      email: yup.string().email().required(),
    });
  });
  const validationErrors = ref({});


  async function sendForm() {
    validationErrors.value = {}

    try {
      await validate(validationSchema.value, formData.value);
    } catch (validationResult: any) {
      validationErrors.value = validationResult;
      throw validationResult;
    }

    isLoading.value = true;
    try {
      const payload = Object.assign({}, formData.value);
      payload.format = formData.value.format.join(', ');
      await sendBusinessFormUseCase.send(payload);
      clearForm();
    } finally {
      isLoading.value = false;
    }
  }

  function clearForm() {
    formData.value = {
      company: null,
      countOfStaff: null,
      format: null,
      name: null,
      phone: null,
      country: 'ua',
      email: null,
    };
    validationErrors.value = {};
  }


  return {
    isLoading,
    formData,
    validationErrors,
    sendForm,
  }
}
